import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      header: {
        margin: theme.spacing(2, 0, 1),
        '& *': {
          boxSizing: 'border-box',
        },
        '& > h1': {
          marginBottom: theme.spacing(2),
        }
      },
      content: {
        '& *': {
          boxSizing: 'border-box',
        },
      },
      situacao: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 16,
        lineHeight: 1.5,
        color: sicrediColor.secondarySicrediDarker,
      },
      loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        width: '100%',
        height: '100vh',
        padding: theme.spacing(),
        boxSizing: 'border-box'
      },
      data: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
      },
      botoesSituacao: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          justifyContent: 'center',
        },
        '& .MuiButton-root:not(:last-of-type)': {
          marginRight: theme.spacing(2.5),
        },
      },
      botaoBloquear: {
        backgroundColor: 'transparent',
        borderColor: sicrediColor.dangerSicredi,
        borderWidth: '1px',
        borderStyle: 'solid',
        color: sicrediColor.dangerSicredi,
        '&:hover': {
          borderColor: sicrediColor.dangerSicrediDark,
          filter: 'brightness(0.88)',
        },
      },
      syncLabel: {
        fontWeight: 'bold',
      },
      updatePresence: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
      },
      loading: {
        alignSelf: 'center'
      },
      labelGrid: {
        display: 'grid',
        [theme.breakpoints.up('xs')]: {
          gridTemplateColumns: 'repeat(1, 1fr)',
          gap: '16px'
        },
        [theme.breakpoints.up('md')]: {
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '24px'
        },
        [theme.breakpoints.up('lg')]: {
          gridTemplateColumns: 'repeat(5, 1fr)',
          gap: '30px',
        },
      },
      labelValueIcon: {
        fontSize: '1.2em',
      },
      gridItem: {
        '& > *': {
          boxSizing: 'border-box',
          height: '100%'
        }
      },
      pautasWarning: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'left',
        '& p': {
          marginLeft: theme.spacing(1)
        }
      },
      pautaAlertIcon: {
        color: sicrediColor.warningSicredi
      },
      infoCard: {
        boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.1) !important'
      }
    }),
  { name: 'AssembleiaAssessor' }
);
